import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  // private paymentObserver?: MutationObserver;
  // updatePrice = (event) => {
  //   if (event.detail.data.newProduct) {
  //     this.dataset.productId = event.detail.data.newProduct.id;
  //   } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
  //     return;
  //   }

  //   const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
  //   const currentPrice = this.querySelector('[ref="priceContainer"]');

  //   if (!newPrice || !currentPrice) return;

  //   if (currentPrice.innerHTML !== newPrice.innerHTML) {
  //     currentPrice.replaceWith(newPrice);
  //   }
  // };

  updatePrice = (event) => {
  if (event.detail.data.newProduct) {
    this.dataset.productId = event.detail.data.newProduct.id;
  } else if (
    event.target instanceof HTMLElement &&
    event.target.dataset.productId !== this.dataset.productId
  ) {
    return;
  }

  const newPrice = event.detail.data.html.querySelector(
    'product-price [ref="priceContainer"]'
  );

  const currentPrice = this.querySelector('[ref="priceContainer"]');

  if (!newPrice || !currentPrice) return;

  if (currentPrice.innerHTML !== newPrice.innerHTML) {
    currentPrice.replaceWith(newPrice);
  }

  // Replace payment terms
  const newTerms = event.detail.data.html.querySelector(
    'product-price shopify-payment-terms'
  );

  const currentTerms = this.querySelector('shopify-payment-terms');

  if (newTerms && currentTerms) {
    currentTerms.replaceWith(newTerms);
  }

  // Remove previous observer
  this.paymentObserver?.disconnect();

  // Discount from Liquid
  const discount = Number(this.dataset.discount || 0);

  const updateInstallment = () => {
    const terms = this.querySelector("shopify-payment-terms");

    if (!terms?.shadowRoot) return;

    // Find selected variant
    const variantId = Number(
      document.querySelector('input[name="id"]')?.value
    );

    if (!variantId) return;

    // Find variants JSON automatically
    const variantsScript = [...document.querySelectorAll('script[type="application/json"]')]
      .find((script) => {
        try {
          const json = JSON.parse(script.textContent || "");
          return (
            Array.isArray(json) &&
            json.length &&
            json[0].id &&
            json[0].price
          );
        } catch {
          return false;
        }
      });

    if (!variantsScript) return;

    const variants = JSON.parse(variantsScript.textContent || "[]");

    const variant = variants.find((v) => v.id === variantId);

    if (!variant) return;

    const discountedPrice =
      (variant.price / 100) * (1 - discount / 100);

    const installment = discountedPrice / 4;

    const amount =
      terms.shadowRoot.querySelector(".font-bold");

    if (!amount) return;

    amount.textContent = new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD",
    }).format(installment);
  };

  // Retry until Shopify finishes rendering
  let retry = 0;

  const wait = () => {
    retry++;

    const terms = this.querySelector("shopify-payment-terms");

    if (!terms?.shadowRoot) {
      if (retry < 20) {
        setTimeout(wait, 250);
      }
      return;
    }

    updateInstallment();

    this.paymentObserver = new MutationObserver(() => {
      updateInstallment();
    });

    this.paymentObserver.observe(terms.shadowRoot, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  };

  wait();
};
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
